import Card from '@app/card';

export default class Section {
  id?: number;
  layout?: {type?: string};
  sources: Card[];
  subsections?: {id?: number, sources: Card[], title: string}[];
  title: string;
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/section.ts